import {useEffect} from "react";
import { useLocation } from "react-router-dom";


const ScrollToTop = () => {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // A hash means the link is aiming at a section on the next page, so
        // leave the scroll position alone and let HashLink land on the anchor.
        // Without this, navigating cross-route to /page#section jumps to the top
        // and the anchor never wins the race.
        if (hash) return;
        window.scrollTo(0, 0);
    }, [pathname, hash]);

    return null;
};

export default ScrollToTop;
